const FacilityAlertEndpointFetchOneRequestHttpQueryParams = (request) => {
    return {
        date_type: request.options?.date_type,
    };
};
export const FacilityAlertEndpoint = (makeRequest) => {
    return {
        // checks to see if we should be displaying an in app alert to patients on web and mobile
        // for facility closures such as for holidays (New Years Eve) or emergency closures
        fetchOne(params, options) {
            return makeRequest('GET', '/v2/facility_alert', FacilityAlertEndpointFetchOneRequestHttpQueryParams(params), options);
        },
    };
};
//# sourceMappingURL=facility_alert_endpoint.js.map